import request from '@shared/utils/request'

export function getAppList(data) {
  return request({
    url: '/sys-app-version/list',
    method: 'post',
    data
  })
}

export function updateApp(data) {
  return request({
    url: '/sys-app-version/update',
    method: 'post',
    data
  })
}

export function addApp(data) {
  return request({
    url: '/sys-app-version/add',
    method: 'post',
    data
  })
}
export function appList(data) {
  return request({
    url: '/sys-app-version/appList',
    method: 'post',
    data
  })
}

export function updateStatus(params) {
  return request({
    url: '/sys-app-version/updateStatus',
    method: 'post',
    params
  })
}
